export default `---
slug: erasmus-kth
type: education
dateRange: "Aug 2020 – Feb 2021"
institution: "KTH Royal Institute of Technology"
location: "Stockholm, Sweden"
role: "Erasmus Exchange Student"
current: false
sortKey: "2021-02"
skills: [Machine Learning, Neural Networks, Computer Vision, Reinforcement Learning, Python, MATLAB, Deep Learning]
relatedLinks:
  - label: "Sweden"
    href: /travel/sweden
  - label: "Artificial Neural Networks"
    href: /projects/neural-networks
  - label: "Computer Vision"
    href: /projects/computer-vision
  - label: "Reinforcement Learning"
    href: /projects/reinforcement-learning
---

From August 2020 to February 2021, I did my Erasmus at KTH Royal Institute of Technology in Stockholm — a really great experience that shaped my career fundamentally. From a career and education point of view, this semester was extremely hands-on and practical, with a big focus on Machine Learning, Neural Networks, Computer Vision, and Reinforcement Learning. This is when my passion for coding and AI really came alive.

I arrived as an engineer who had touched Python a few times; I left as someone who genuinely loved the craft of building intelligent systems. The colleagues I met there — Stefano, Vittorio, Rodrigo, Etienne — became real friends, and learning alongside people who were stronger than me at coding pushed me to grow faster than any classroom ever could. The Swedish winter helped too: not much else to do but study, experiment, and joke around.
`;
